import _ from "lodash";

export function getSectionSchema({ schema, sections }) {
  const groupedSchemas = _.groupBy(schema, "section");
  return _.mapValues(sections, (s) => {
    const gs = groupedSchemas[s.sectionKey];
    if (s.group && s.group.length > 0) {
      s.configSchemas = getGroupSchema({
        schema: gs,
        groups: s.group,
      });
    }

    return {
      configSchemas: gs,
    };
  });
}

export function getGroupSchema({ schema, groups }) {
  return _.reduce(
    groups,
    (result, group) => {
      const { groupName, keys } = group;
      _.forEach(keys, (key) => {
        const item = _.find(schema, (s) => s.key === key);
        if (item) {
          item.groupCategory = groupName;
          result.push(item);
        }
      });

      return result;
    },
    []
  );
}
